var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    id: "Swipe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a6c693",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.033,10.351a2,2,0,0,0,0-2.829,2.049,2.049,0,0,0-2.828,0l-4.439,4.439a1.972,1.972,0,0,0-.511-.9,2,2,0,0,0-2.28-.38,1.982,1.982,0,0,0-.548-1.034,2.049,2.049,0,0,0-2.28-.372A1.988,1.988,0,0,0,11.6,8.229a2.049,2.049,0,0,0-2.828,0L4.229,12.771A6.06,6.06,0,0,0,2.936,14.68a6.826,6.826,0,0,0,1.455,7.554L6.156,24A6.76,6.76,0,0,0,10.9,26.011l.168,0a16.479,16.479,0,0,0,2.752-.319l5.809-1.162a1.483,1.483,0,0,0,1.036-2.117A3.518,3.518,0,0,0,17.5,20.457H15.248a.133.133,0,0,1-.095-.227ZM14.2,20.758a1.129,1.129,0,0,0,1.047.7H17.5a2.522,2.522,0,0,1,2.268,1.4.483.483,0,0,1-.337.69L13.622,24.71a15.505,15.505,0,0,1-2.583.3,5.742,5.742,0,0,1-4.176-1.716L5.1,21.527a5.831,5.831,0,0,1-1.243-6.453,5.064,5.064,0,0,1,1.081-1.6L9.477,8.937a1.025,1.025,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-.353.353a.5.5,0,0,0,.707.707l1.06-1.06a1,1,0,0,1,1.415,1.414l-.354.353a.5.5,0,0,0,.707.707l1.061-1.06a1,1,0,0,1,1.415,1.413l-.708.708a.5.5,0,1,0,.707.707l.706-.707h0l0,0,5.655-5.655a1.025,1.025,0,0,1,1.414,0,1,1,0,0,1,0,1.415l-9.88,9.879A1.13,1.13,0,0,0,14.2,20.758Z",
    fill: "#a6c693",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.961,7.909a.5.5,0,0,0,.366-.159,9.833,9.833,0,0,1,5.82-3.018A9.7,9.7,0,0,1,17.7,6.123l-2.846.466a.5.5,0,0,0,.08.993.459.459,0,0,0,.081-.007l3.947-.645a.5.5,0,0,0,.414-.575l-.646-3.947a.5.5,0,0,0-.988.162l.439,2.677a10.662,10.662,0,0,0-7.171-1.5A10.829,10.829,0,0,0,4.6,7.068a.5.5,0,0,0,.365.841Z",
    fill: "#a6c693",
    className: "color000000 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipe);
export default __webpack_public_path__ + "static/media/swipe.4e0451a0ac404491d3c74610e6212dc1.svg";
export { ForwardRef as ReactComponent };